import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  & > a {
    text-decoration: none;
    color: black;
  }
`

export const PromisePointWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  min-width: 200px;
  max-width: 300px;
  text-align: center;
  border: 1px solid #ccc;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;

  &:hover {
    cursor: pointer;
    background-color: #f5f5f5;
  }
`

export const IconBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--brand-primary);
`

export const Title = styled.h2`
  margin-top: 10px;
`

export const Text = styled.p`
  margin-top: 5px;
  font-weight: var(--font-light);
`
